import React from 'react';

import CreateForm from './createform';
import Togglable from '../togglable';

const Modal = Togglable(({ user, form, allow_add, updateCommentField, saveComment, cancelComment }) => (
	<>
		<div className="modal-backdrop fade show" onClick={cancelComment}></div>
		<div aria-label="Add comment" className="modal fade show" id="modal-comment-add" role="dialog" tabindex="-1" style={{"display": "block"}}>
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h3 className="modal-title">{form.dialog_title}</h3>
						<button aria-label="Close" className="close" onClick={cancelComment} type="button"><span aria-hidden="true">×</span></button>
					</div>
					<div className="modal-body">
						<CreateForm
							actionlabel="Save"
							user={user}
							values={form}
							updateCommentField={updateCommentField}
							saveComment={saveComment}
							message={form.message}
							message_colour={form.message_colour}
							allow_add={allow_add}
						/>
					</div>
					<div className="modal-footer">
						<button className="btn btn-flat-secondary" data-dismiss="modal" type="button" onClick={cancelComment}>Cancel</button>
						<button className="btn btn-flat-secondary" type="button" onClick={()=>saveComment()}>Save</button>
					</div>
				</div>
			</div>
		</div>
	</>
));

export default Modal;